module.exports = __webpack_public_path__ + "static/img/6.7e7cfd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/6.jpg
// module id = ayV3
// module chunks = 5